import { useRouter } from "next/router";
import React, { useState } from "react";
import OnHoverOption from "@/components/PaidUsers/OnHoverOption";
import { putComma } from "@/lib/utils";
import { Mixpanel } from "@/elements/Mixpanel";
import Actions from "@/elements/Actions";
import { getLivePrice } from "@/lib/tradeCards";

const TopOptionsDesktopSection = ({ activeChartType, finCode: parentFinCode, OPTIONS, fnoData }) => {
    return (
        <div className="mx-auto py-4 flex flex-col items-start self-stretch max-w-full">
            <div className="flex flex-col items-start gap-4 self-stretch">
                <h2 className="px-4 text-black font-Inter text-base font-semibold">Options</h2>

                <div className="flex justify-between items-start self-stretch pt-0 pb-2 px-4">
                    <div className="flex items-start gap-4 self-stretch w-full">
                        {OPTIONS.map((filter, index) => (
                            <TopOptionsDesktop
                                key={index}
                                filter={filter}
                                data={fnoData[filter.value]}
                                activeChartType={activeChartType}
                                parentFinCode={parentFinCode}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <style>{`
            input[type="radio"]:checked {
  background-color: #00439D
}
            `}</style>
        </div>
    );
};

export default TopOptionsDesktopSection;

export function TopOptionsDesktop({ filter, data, activeChartType, parentFinCode }) {
    const [subFilter, setSubFilter] = useState("callOptions");

    return (
        <div className="w-1/3  border border-[#E2F2FF] rounded-[16px] overflow-hidden">
            <div className="flex items-center justify-between pb-2 bg-[#E2F2FF] p-3">
                <h3 className="text-sm font-bold">By {filter.key?.toLowerCase()}</h3>
                <div className="flex items-center gap-3">
                    <input
                        type="radio"
                        id={`${filter.key}-call`}
                        name={`${filter.key}-status`}
                        value="callOptions"
                        checked={subFilter === "callOptions"}
                        onChange={() => {
                            Mixpanel.track("option_clicked", {
                                page: "Index_f&o",
                                option: "callOptions"
                            }),
                                setSubFilter("callOptions");
                        }}
                    />
                    <label htmlFor={`${filter.key}-call`}>Call</label>
                    <input
                        type="radio"
                        id={`${filter.key}-put`}
                        name={`${filter.key}-status`}
                        value="putOptions"
                        checked={subFilter === "putOptions"}
                        onChange={() => {
                            Mixpanel.track("option_clicked", {
                                page: "Index_f&o",
                                option: "putOptions"
                            }),
                                setSubFilter("putOptions");
                        }}
                    />
                    <label htmlFor={`${filter.key}-put`}>Put</label>
                </div>
            </div>

            {data?.[subFilter]?.map((ele, i, arr) => (
                <TopOptionsCard
                    key={i}
                    i={i}
                    arr={arr}
                    ele={ele}
                    activeChartType={activeChartType}
                    parentFinCode={parentFinCode}
                />
            ))}
        </div>
    );
}

export function TopOptionsCard({ i, arr, ele, activeChartType, parentFinCode }) {
    const router = useRouter();
    return (
        <div
            className={`cursor-pointer group px-3 relative flex items-center justify-between self-stretch border-solid group hover:bg-[#F0F7FF] py-2 ${
                i !== arr.length - 1 ? "border-b-[#DFDFDF] border-b" : ""
            }`}
            onClick={() => {
                Mixpanel.track("cta_clicked", {
                    page: "Index_sdp",
                    widget: "index_option",
                    fincode: ele?.finCode,
                    symbol: ele?.symbol
                }),
                    router.push(Actions.toFNODetail(`${parentFinCode}-${ele?.finCode}`));
            }}
        >
            <div className="flex justify-between w-full items-center gap-4">
                <div className="flex flex-col items-start gap-1 flex-[1_0_0] self-stretch text-[#202020] font-Inter text-sm font-semibold leading-6">
                    <p className="self-stretch text-xs font-semibold leading-5 text-[#202020] font-Inter lg:text-sm lg:leading-6">
                        {ele.title}
                    </p>
                    <p className="self-stretch text-[10px] text-[#9D9D9D] font-Inter text-xs font-medium leading-5">
                        Vol: {Actions.trimNumber(ele?.volume)} | OI: {Actions.trimNumber(ele?.oi)}
                    </p>
                </div>
                <div className="flex flex-col items-start gap-1 opacity-100 group-hover:opacity-0 transition-opacity duration-300">
                    <div className="self-stretch text-[#202020] text-right font-Inter text-sm font-semibold leading-6">
                        ₹{putComma(ele?.ltpPrice)}
                    </div>
                    <div
                        style={{
                            color: ele?.ltpPrice - ele?.closePrice >= 0 ? "#4CAF50" : "#EB4E2C"
                        }}
                        className="self-stretch text-right font-Inter text-xs font-medium leading-5"
                    >
                        {putComma(((ele?.ltpPrice - ele?.closePrice) * 100) / ele?.closePrice)}%
                    </div>
                </div>
            </div>
            <OnHoverOption
                bseSymbol={ele?.symbol}
                nseSymbol={ele?.symbol}
                finCode={ele?.finCode}
                exchange={activeChartType === 1 ? "NSE" : "BSE"}
                source="market_home"
                onClickTradingView={() => {
                    getLivePrice([ele?.finCode]).then((res) => {
                        if (res[ele?.finCode]) {
                            Mixpanel.track("cta_clicked", {
                                page: "Index_sdp",
                                widget: "index_option",
                                fincode: ele?.finCode,
                                symbol: ele?.symbol
                            }),
                                router.push(Actions.toFNODetail(`${parentFinCode}-${ele?.finCode}/charts`));
                        }
                    });
                }}
            />
        </div>
    );
}
